/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const propTypes = {
  onDelete: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class DeviceSerieButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.deviceserie');
  }

  render() {
    const { onDelete } = this.props;
    return (
      <div className={styles.btnGroup}>
        <Button
          id="group-by"
          bsStyle="aisz-device"
        >
          <i className="fa fa-hdd-o" aria-hidden="true" />{' '}
          {this.intlMsg.msg('label')}
        </Button>
        <Button
          bsStyle="aisz-device"
          className={styles.closeBtn}
          onClick={onDelete}
        >
          <i className="fa fa-times" />
        </Button>
      </div>
    );
  }
}

DeviceSerieButton.propTypes = propTypes;

export default injectIntl(DeviceSerieButton);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/DeviceSerieButton/index.jsx